/**
 * Brand Assets Utility
 *
 * Reads brand name, logo URL and favicon URL from environment variables.
 *
 * The document referrer policy is set to "same-origin" in index.html, which
 * means no Referer header is sent for cross-origin requests. This prevents
 * hotlink-protection 403s on the CDN without requiring fetch or CORS.
 *
 * Exposed values:
 *   BRAND_NAME       – string, e.g. "Botamation"
 *   getBrandLogoSrc  – () => string  (returns the logo URL from env)
 *   initBrandAssets  – () => void    call once at app startup (index.js)
 */

export const BRAND_NAME     = process.env.REACT_APP_BRAND_NAME     || 'App';
const BRAND_LOGO_URL        = process.env.REACT_APP_BRAND_LOGO_URL  || '';
const BRAND_FAVICON_URL     = process.env.REACT_APP_BRAND_FAVICON_URL || '';

/** Returns the logo URL declared in the environment. */
export function getBrandLogoSrc() {
    return BRAND_LOGO_URL;
}

/**
 * Call once at app startup (e.g. in index.js before render).
 * Sets the page title and injects the favicon <link>.
 */
export function initBrandAssets() {
    document.title = BRAND_NAME;

    if (!BRAND_LOGO_URL) {
        console.warn('[BrandAssets] REACT_APP_BRAND_LOGO_URL is not set — logo will not be displayed.');
    }

    if (BRAND_FAVICON_URL) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = BRAND_FAVICON_URL;
    }
}
